const SMS_PROVIDERS = {
  k7: {
    label: "Bulk SMS Gateway",
    icon: "/img/icons/bulksms.png",
    websiteUrl: "https://sms.smswala.in",
    description:
      "DLT-compliant SMS gateway integration for OTP, transactional and promotional SMS using the K7 SMS API.",
    setupSteps: [
      "Login to your Bulk SMS gateway account.",
      "Copy your API Key from the SMS API section.",
      "Enter your DLT Registered Entity ID (PE ID).",
      "Enter your approved Sender ID / Header.",
      "Enter the Route ID values provided by K7 for OTP and Transactional SMS.",
      "Enter the approved SMS Template ID while creating SMS templates.",
      "Save settings and send a test SMS to verify the configuration.",
    ],
    fields: [
      {
        name: "apiUrl",
        label: "API URL",
        required: true,
        placeholder: "https://bulksmslogin.in/app/smsapi/index.php",
        helperText: "K7 SMS API endpoint.",
      },

      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "Enter K7 API Key",
        helperText: "Available from your SMS gateway account.",
      },

      {
        name: "peId",
        label: "DLT Entity ID (PE ID)",
        required: true,
        placeholder: "1701158000000000000",
        helperText: "Your DLT registered Principal Entity ID.",
      },

      {
        name: "senderId",
        label: "Sender ID / Header",
        required: true,
        placeholder: "MYSHOP",
        helperText: "DLT-approved Sender ID / Header.",
      },

      {
        name: "campaign",
        label: "Campaign Value",
        required: true,
        placeholder: "XXXXX",
        helperText: "Campaign Value.",
      },

      {
        name: "type",
        label: "SMS Type",
        required: true,
        placeholder: "text",
        helperText: "K7 API message type. Usually text.",
      },

      {
        name: "otpRouteId",
        label: "OTP Route ID",
        required: true,
        placeholder: "4",
        helperText:
          "Route ID provided by K7 for OTP SMS. This value can differ by provider/account.",
      },

      {
        name: "transactionRouteId",
        label: "Transactional Route ID",
        required: true,
        placeholder: "2",
        helperText: "Route ID provided by K7 for Transactional SMS.",
      },

      {
        name: "promotionalRouteId",
        label: "Promotional Route ID",
        required: false,
        placeholder: "1",
        helperText:
          "Route ID provided by K7 for Promotional SMS, if applicable.",
      },
    ],
  },
  ping4sms: {
    label: "Ping4SMS",
    icon: "/img/icons/ping4sms.png",
    websiteUrl: "http://site.ping4sms.com",

    description:
      "Connect Ping4SMS for transactional, OTP and DLT-based SMS delivery.",

    setupSteps: [
      "Login to your Ping4SMS account.",
      "Copy the SMS API URL provided by Ping4SMS.",
      "Enter your SMS API Key.",
      "Enter your approved Sender ID.",
      "Configure the route value provided by Ping4SMS.",
      "SMS Template ID will be configured separately in the SMS Template section.",
      "Save settings and test the SMS integration.",
    ],

    fields: [
      {
        name: "apiUrl",
        label: "API URL",
        required: true,
        placeholder: "http://site.ping4sms.com/api/smsapi",
        helperText: "Ping4SMS SMS API endpoint.",
      },

      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "Enter Ping4SMS API Key",
        helperText: "API key provided by Ping4SMS.",
      },

      {
        name: "senderId",
        label: "Sender ID",
        required: true,
        placeholder: "XYZ",
        helperText: "Approved sender/header configured in your account.",
      },

      {
        name: "route",
        label: "Route",
        required: true,
        placeholder: "2",
        helperText: "Route value provided by Ping4SMS.",
      },

      {
        name: "countryCode",
        label: "Country Code",
        required: false,
        placeholder: "91",
        helperText: "Default country code if required by the provider.",
      },
    ],
  },
  smsalert: {
    label: "sms Alert",
    icon: "/img/icons/smsalert.webp",
    websiteUrl: "https://www.smsalert.co.in",
    description: "Connect smsAlert for transactional, OTP and DLT-based SMS delivery.",
    setupSteps: [
      "Login to your smsAlert account.",
      "Copy the SMS API URL provided by smsAlert.",
      "Enter your SMS API Key.",
      "Enter your approved Sender ID.",
      "Configure the route value provided by smsAlert.",
      "SMS Template ID will be configured separately in the SMS Template section.",
      "Save settings and test the SMS integration.",
    ],
    fields: [
      {
        name: "apiUrl",
        label: "API URL",
        required: true,
        placeholder: "https://www.smsalert.co.in/api/smsapi",
        helperText: "Ping4SMS SMS API endpoint.",
      },
      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "Enter smsAlert API Key",
        helperText: "API key provided by smsAlert.",
      },
      {
        name: "senderId",
        label: "Sender ID",
        required: true,
        placeholder: "XYZ",
        helperText: "Approved sender/header configured in your account.",
      },
    ],
  },
};

export default SMS_PROVIDERS;
